import React, { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import LandingHeader from "../Components/LandingHeader";
import ReactDatatable from "@ashvin27/react-datatable";
import { Images } from "../Components/Images";
import InnerFooter from "../Components/InnerFooter";

import { getTransaction } from "../actions/markets";
import { getAccount } from "../Hooks/useAccount";
import Header from "../layout/Header";
import NewFooter from "../layout/Footer";
import { FaEye } from "react-icons/fa";

import Config from '../Config/index'
import CopyToClipboard from 'react-copy-to-clipboard'
import toast from "react-hot-toast";
import { getCommissions, getUserBycode } from "../actions/user";
import { useSelector } from "react-redux";
import { dateTimeFormat } from "../lib/dateTimeHelper";


const Referral = () => {


  const { walletaddress } = useSelector((state) => state.wallet);
  console.log("🚀 ~ Referral ~ walletaddress:", walletaddress)
  const [pageNumer, setPageNumer] = useState(1);
  const [limit, setLimit] = useState(10);
  const [count, setCount] = useState(0);
  const [totalearn, settotalearn] = useState(0);


  const config = {
    page_size: 10,
    length_menu: [10, 20, 50],
    filename: "Emailtemplates",
    language: {
      length_menu: "Show _MENU_ result per page",
      no_data_text: "No Data found",
      loading_text: "No Data Found",
      filter: "Filter in records...",
      info: "Showing _START_ to _END_ of _TOTAL_ records",
      pagination: {
        first: "First",
        previous: "Previous",
        next: "Next",
        last: "Last",
      },
    },
    show_length_menu: false,
    show_filter: false,
    show_pagination: true,
    show_info: false,
  };

  const columns = [
    {
      key: "sno",
      text: "S.No",
      className: "name",
      align: "center",
      sortable: true,
      cell: (record, i) => {
        return <p className="mb-0">{i + 1}</p>;
      },
    },


    {
      key: "fromwalletAddress",
      text: "Wallet Address",
      className: "address",
      align: "center",
      sortable: true,
      cell: (record) => {
        return (
          <div className="d-flex justify-content-center align-items-center gap-2">
            <p> {`${record?.fromwalletAddress.substring(0, 6)}...${record?.fromwalletAddress.substring(
              36,
              42
            )}`}</p>
          </div>
        );
      },
    },
    // {
    //   key: "towalletAddress",
    //   text: "Earned By",
    //   className: "address",
    //   align: "center",
    //   sortable: true,
    //   cell: (record) => {
    //     return (
    //       <div className="d-flex justify-content-center align-items-center gap-2">
    //         <p> {`${record?.towalletAddress.substring(0, 6)}...${record?.towalletAddress.substring(
    //           36,
    //           42
    //         )}`}</p>
    //       </div>
    //     );
    //   },
    // },
    {
      key: "amount",
      text: "Amount",
      className: "address",
      align: "center",
      sortable: true,
      cell: (record) => {
        return (
          <div className="d-flex justify-content-center align-items-center gap-2">
            <p>{`${record?.amount} ${record?.currency}`}</p>
          </div>
        );
      }
    },
    // subscription bot
    {
      key: "type",
      text: "Earned By",
      className: "address",
      align: "center",
      sortable: true,
      cell: (record) => {
        return (
          <div className="d-flex justify-content-center align-items-center gap-2">
            <p>{record?.type === "refferal" ? "subscription bot" : "profit bot"}</p>
          </div>
        );
      }
    },
    {
      key: "transactionHash",
      text: "Hash",
      className: "address",
      align: "center",
      sortable: true,
      cell: (record) => {
        return (
          <div className="d-flex justify-content-center align-items-center gap-2">
            {/* <button
            >
              <img
                src={require("../Assets/Images/greencheck.svg").default}
                className="img-fluid table_activity_img"
              />{" "}

            </button> */}
            <a href={`https://polygonscan.com/tx/${record.transactionHash}`} target="_blank" >
              <FaEye size={16} className="view_icon" />
            </a>
          </div >
        );
      },
    },
    {
      key: "updatedAt",
      text: "Date",
      className: "address",
      align: "center",
      sortable: true,
      cell: (record) => {
        return (
          <div className="d-flex justify-content-center align-items-center gap-2">
            <p>{dateTimeFormat(record.updatedAt, 'DD:MM:YYYY HH:mm')}</p>
          </div>
        );
      },
    },
  ];

  const records = [
    {
      walletAddress: "12e313xcsdas",
      amount: "12",
      earnedBy: "1234",
    },
  ];
  const [user, setUser] = useState()

  const [commissionData, setcommissionData] = useState([])

  const getCommissionData = async () => {
    try {
      let { status, message, data, count } = await getCommissions({
        walletAddress: walletaddress, page: pageNumer,
        limit: limit,
      })

      const totalAmount = data
        .map(data => parseFloat(data.amount))
        .reduce((sum, amount) => sum + amount, 0);
      settotalearn(totalAmount)

      console.log("Total Amount:", data, totalAmount);
      setcommissionData(data)
      setCount(count);
    }
    catch (err) {
      console.log(err)
    }
  }

  useEffect(() => {
    let userData = sessionStorage.getItem('user')
    console.log("🚀 ~ useEffect ~ userData:", userData)
    userData = JSON.parse(userData)
    setUser(userData)

    // UserDatabyCode()
  }, [walletaddress])





  useEffect(() => {
    getCommissionData()
  }, [walletaddress])



  const handlePagination = async (index) => {
    let reqData = {
      page: index.page_number,
      limit: index.page_size,
      walletAddress: walletaddress,
    };

    setPageNumer(index.page_number);
    setLimit(index.page_size);
    const { status, message, data, count } = await getCommissions(reqData);
    console.log("🚀 ~ handlePagination ~ status, message, result, count :", status, message, data, count)
    setcommissionData(data);
    setCount(count);
  };

  useEffect(() => {
    window.scroll(0, 0);
  }, []);

  return (
    <>
      <div className="common_bgVideo referral_page">
        {/* <video
          src={Images.bannerBg_vdo}
          autoPlay
          muted
          loop
          className="img-fluid video_src"
        />
        <div className="overlay_bg" />

        <img
          src={Images.planlftOvly}
          className="opportunity__lftBlur img-fluid"
        />
        <img
          src={Images.planrytOvly}
          className="opportunity__rightBlur img-fluid"
        /> */}
        <Header />
        <Container
          fluid
          className="p-0 custom_container"
        >
          <Container className="home__indexAligner innerpages_ui">
            <div className="plans__holder pb-3 pb-lg-4">
              <h4 className="m-0 hebrew_bold opportunity__title">Referral</h4>
              <p className="plans__titleHint m-0 hebrew_font position-relative mt-2">
                Invite others to Sector-8 and earn rewards every time they trade. Share your personal referral link,
                grow the community, and get a cut of the profits              </p>

              <div className="dashboard__blueBox rounded-2 mt-3 mt-lg-5">
                <div className="referral_linkSec">
                  <p className="title_txt mb-0">My referral link</p>
                  <div className="referral_link mt-3">
                    <input
                      type="text"
                      className="link_input position-relative hebrew_font w-100"
                      placeholder="Balance"
                      // value="https://flashchain.com/signup?_go=50ffj"

                      value={`${Config.FRONT_URL}/${user?.referralCode}`}

                    />
                    <CopyToClipboard
                      text={`${Config.FRONT_URL}/${user?.referralCode}`}
                      onCopy={() => { toast.success("Link copied!") }}
                    >
                      <button className="copy_btn linear_btn">
                        Copy
                      </button>
                    </CopyToClipboard>
                  </div>
                </div>


                <div className="cusotm_tableSec">
                  <div className="total_earned">
                    <img
                      src={Images.totalEarnedBg}
                      className="totalEar_bg_src"
                    />
                    <div className="total_val">
                      <p className="title_txt mb-0">
                        Total Earned: <span className="val">{totalearn} USDT</span>
                      </p>
                    </div>
                  </div>

                  {console.log("commissionDatacommissionData", commissionData)}

                  <div className="transacHistory__tableHolder">
                    <ReactDatatable
                      config={config}
                      records={commissionData}
                      columns={columns}
                      total_record={count}
                      dynamic={true}
                      onChange={(e) => {
                        handlePagination(e);
                      }}
                    // loading={true}
                    // loading={([null, undefined].includes(commissionData) || []) ? true : false}
                    />
                  </div>
                </div>


              </div>
            </div>
          </Container>
        </Container>
      </div>
      <NewFooter />
    </>
  );
};

export default Referral;
